module.exports = __webpack_public_path__ + "img/4. Empire state building.146b03b5.png";